module.exports = __webpack_public_path__ + "static/media/REAID.a44727de.jpg";